import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Tag,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getPatients } from '../../../network/appointment';
import {
  addPatientInsurancePolicy,
  getEligibilityPlans,
  getInsurancePayors,
  getPatientInsurancePolicies,
  getPatientInsurancePoliciesById,
  getPayorContracts,
  getPriceListAndRate,
  getValidPatientInsurancePolicies,
  updatePatientInsurancePolicy,
} from '../../../network/PatientInsurancePolicy';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getAllItems,
  getItemInsuranceEligibility,
} from '../../../network/ItemEligibility';
import {
  addPatientInsurance,
  getPatientInsuranceCoverageById,
  updatePatientInsurance,
} from '../../../network/PatientCoverage';
import StatusTag from '../../../hooks/StatusHook';

const PatientCoverageAdd = ({ t, edit }) => {
  // addPatientInsurancePolicy;
  const { id } = useParams();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const navigate = useNavigate();
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const { data: patients } = useQuery({
    queryKey: [queryKeys.getPatients],
    queryFn: () => getPatients(),
    keepPreviousData: true,
  });
  const patientNumber = Form.useWatch('patient', form);

  const { data: policies } = useQuery({
    queryKey: [queryKeys.getValidPatientInsurancePolicies],
    queryFn: () => getValidPatientInsurancePolicies(patientNumber),
    select: (data) => data?.message,
    enabled: !!patientNumber,
    keepPreviousData: true,
  });
  console.log(policies, 'policies');
  const { data: payors } = useQuery({
    queryKey: [queryKeys.getInsurancePayors],
    queryFn: () => getInsurancePayors(),
    keepPreviousData: true,
  });
  const { data: plans } = useQuery({
    queryKey: [queryKeys.getEligibilityPlans],
    queryFn: () => getEligibilityPlans(),
    keepPreviousData: true,
  });
  const { data: ItemEligibility } = useQuery({
    queryKey: [queryKeys.getItemInsuranceEligibility],
    queryFn: () => getItemInsuranceEligibility(),
    keepPreviousData: true,
  });
  // const { data: allItems } = useQuery({
  //   queryKey: [queryKeys.getAllItems],
  //   queryFn: () => getAllItems(),
  //   keepPreviousData: true,
  // });
  const { data: contracts } = useQuery({
    queryKey: [queryKeys.getPayorContracts],
    queryFn: () => getPayorContracts(),
    keepPreviousData: true,
  });
  const { mutate: onAddPatientCoverage } = useMutation({
    mutationKey: ['addPatientCoverage'],
    mutationFn: (body) =>
      edit ? updatePatientInsurance({ body, id }) : addPatientInsurance(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data, 'datawwww');
      if (data?.message?.status === 500 || data === undefined) {
        message.error(data?.message?.message || 'Something went wrong !');
        return false;
      }
      // edit
      //   ? message.success('Patient edited successfully')
      //   : message.success('Patient added successfully');
      message.success(
        data?.message?.message || edit
          ? ' Patient Coverage Edited Successfully'
          : 'Patient Coverage Added Successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getPatientInsuranceCoverage],
      });
      form.resetFields();
      navigate('/patient_coverage');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  const onFinish = (values) => {
    console.log('Finish:', values);
    setLoadingAdd(true);
    onAddPatientCoverage({
      ...values,
      birth_date: dayjs(values?.birth_date).format('YYYY-MM-DD'),
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      policy_expiry_date: dayjs(values?.policy_expiry_date).format(
        'YYYY-MM-DD'
      ),
    });
  };

  const insurance_policy = Form.useWatch('insurance_policy', form);
  const item_code = Form.useWatch('item_code', form);

  const { data: dataById, isLoading } = useQuery({
    queryKey: [queryKeys.getPatientInsuranceCoverage, id],
    queryFn: () => getPatientInsuranceCoverageById(id),
    enabled: !!edit,
    keepPreviousData: true,
  });

  const { data: priceListData } = useQuery({
    queryKey: [queryKeys.getPriceListAndRate, insurance_policy, item_code],
    queryFn: () => getPriceListAndRate({ insurance_policy, item_code }),
    enabled: !!insurance_policy && !!item_code,
    onSuccess: (data) => {
      console.log(data, 'dataaaaaaaaaaaaaaaaa 88888888888');
      // form?.setFieldsValue({  });
    },
    onError: (error) => {
      console.log('error:', error);
    },
  });

  useEffect(() => {
    if (priceListData) {
      const price_list_rate = priceListData?.message?.Rate;
      const price_list = priceListData?.message?.Price_List;
      form.setFieldsValue({
        price_list_rate,
        price_list,
      });
    }
  }, [priceListData, form]);

  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  const handleItemCodeChange = (value, option) => {
    console.log(option, 'option in handleItemCodeChange');
    const price = priceListData?.message?.Rate || 0;
    const discountAmount = (price * option?.option?.discount) / 100;
    const amount = price - discountAmount;
    const coverageAmount = (amount * option?.option?.coverage) / 100;
    form.setFieldsValue({
      // item_eligibility: option?.option?.name,
      item_code: option?.option?.item_code,
      mode_of_approval: option?.option?.mode_of_approval,
      coverage: option?.option?.coverage,
      discount: option?.option?.discount,
      discount_amount: discountAmount,
      amount: amount || 0,
      coverage_amount: coverageAmount || 0,
      // final_amount_due: amount - coverageAmount || 0 ,
    });
  };
  return (
    <div className="patient-insurance-policy">
      <Card>
        <Flex
          align="center"
          justify="space-between"
          style={{ marginBottom: 10 }}
          className="page-header"
        >
          <h4 className="title-card">
            {edit ? t.EDITPATIENTDETAILS : t.ENTERPATIENTDETAILS}
          </h4>
          {edit && <StatusTag status={dataById?.data?.status} />}
        </Flex>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit
              ? {
                  ...dataById?.data,
                  birth_date: dayjs(dataById?.data?.birth_date),
                  posting_date: dayjs(dataById?.data?.posting_date),
                  policy_expiry_date: dayjs(dataById?.data?.policy_expiry_date),
                }
              : {}
          }
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient"
                label={t.patientFileNumber}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientFileNumber,
                  },
                ]}
              >
                <Select
                  placeholder={t.patientFileNumber}
                  onChange={(value, option) => {
                    console.log(option);
                    form.setFieldsValue({
                      patient_name: option?.data?.patient_name,
                      gender: option?.data?.sex,
                      birth_date: dayjs(option?.data?.dob),
                    });
                  }}
                  options={patients?.message?.message?.map((item) => ({
                    value: item?.name,
                    label: item?.custom_file_number,
                    data: item,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient_name"
                label={t.patientName}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredPatientName,
                //   },
                // ]}
              >
                <Input placeholder={t.patientName} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="posting_date"
                label={t.postingDate}
                initialValue={dayjs()}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  placeholder={t.postingDate}
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  format="YYYY-MM-DD"
                  disabledDate={(current) =>
                    current && current < dayjs().startOf('day')
                  }
                />
              </Form.Item>
            </Col>
            <Form.Item
              name="gender"
              label={t.gender}
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
              hidden
            >
              <Input placeholder={t.gender} disabled />
            </Form.Item>
            <Form.Item
              name="birth_date"
              label={t.birthDate}
              initialValue={dayjs()}
              hidden
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <DatePicker
                placeholder={t.date}
                style={{ width: '100%' }}
                defaultValue={dayjs()}
                format="YYYY-MM-DD"
                disabled
              />
            </Form.Item>
            {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="company"
                label={t.company}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.insurancePayor}
                  options={payors?.message?.insurance_payors?.map((item) => ({
                    value: item?.name,
                    label: item?.insurance_payor_name,
                  }))}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={24} md={24} lg={24}>
              <Divider style={{ marginTop: 0 }} placement="left">
                Insurance Details
              </Divider>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_policy"
                label={t.insurancePolicy}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.insurancePolicy}
                  options={policies?.policies?.map((item) => ({
                    value: item?.name,
                    label: item?.name,
                    option: item,
                  }))}
                  onChange={(value, option) => {
                    const insurancePayor = contracts?.data?.find(
                      (item) =>
                        item?.insurance_payor ===
                        option?.option?.insurance_payor
                    );

                    console.log(option);
                    form.setFieldsValue({
                      insurance_payor: option?.option?.insurance_payor,
                      policy_number: option?.option?.policy_number,
                      policy_expiry_date: dayjs(
                        option?.option?.policy_expiry_date
                      ),
                      insurance_plan: option?.option?.insurance_plan,
                      // company: option?.option?.insurance_payor,
                      // posting_date: dayjs(insurancePayor?.posting_date),
                    });
                    // client.invalidateQueries({
                    //   queryKey: [queryKeys.getPriceListAndRate],
                    // });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_payor"
                label={t.insurancePayor}
                // ]}
              >
                <Input placeholder={t.insurancePayor} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="policy_number"
                label={t.PolicyNumber}
                // rules={[
                //   {
                //     required: true,
                //   },
                //   {
                //     min: 10,
                //     message: 'Policy Number must be at least 10 characters',
                //   },
                // ]}
              >
                <Input type="number" placeholder={t.PolicyNumber} disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_plan"
                label={t.InsurancePlan}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Select
                  placeholder={t.InsurancePlan}
                  options={plans?.message?.eligibility_plans?.map((item) => ({
                    value: item?.name,
                    label: item?.insurance_plan_name,
                  }))}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="policy_expiry_date"
                label={t.PolicyExpiryDate}
                initialValue={dayjs()}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <DatePicker
                  placeholder={t.PolicyExpiryDate}
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  format="YYYY-MM-DD"
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Divider style={{ marginTop: 0 }} placement="left">
                Items Details
              </Divider>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="item_eligibility"
                // label={t.itemEligibility}
                label={t.itemCode}
                rules={[
                  {
                    required: true,
                  },
                ]}
                // hidden
              >
                <Select
                  // placeholder={t.itemEligibility}
                  placeholder={t.itemCode}
                  options={ItemEligibility?.data?.map((item) => ({
                    value: item?.name,
                    label: item?.item_code,
                    // label: item?.name,
                    option: item,
                  }))}
                  onChange={(value, option) => {
                    handleItemCodeChange(value, option);
                  }}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={8}> */}
            <Form.Item
              name="item_code"
              label={t.itemCode}
              rules={[
                {
                  required: true,
                },
              ]}
              hidden
            >
              <Select
                placeholder={t.itemCode}
                // options={allItems?.message?.items?.map(
                //   (item) => ({
                //     value: item?.item_code,
                //     label: item?.item_code,
                //     option: item,
                //   })
                // )}
                options={ItemEligibility?.data?.map((item) => ({
                  value: item?.item_code,
                  label: item?.item_code,
                  option: item,
                }))}
                onChange={(value, option) => {
                  handleItemCodeChange(value, option);
                }}
              />
            </Form.Item>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="qty"
                label={t.quantity}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  placeholder={t.quantity}
                  typeof="number"
                />
              </Form.Item>
            </Col>
            {/* </Col> */}
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="mode_of_approval"
                label={t.modeOfApproval}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Select
                  placeholder={t.modeOfApproval}
                  options={[
                    {
                      value: 'Manual',
                      label: t.Manual,
                    },
                    {
                      value: 'Automatic',
                      label: t.Automatic,
                    },
                  ]}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="coverage"
                label={t.coverage}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Input
                  prefix="%"
                  style={{ width: '100%' }}
                  max={100}
                  min={0}
                  type="number"
                  placeholder={t.coverage}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="discount" label={t.discount}>
                <Input
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  placeholder={t.discount}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="discount_amount" label={t.discountAmount}>
                <Input
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  placeholder={t.discountAmount}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="amount" label={t.amount}>
                <Input
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  placeholder={t.amount}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="coverage_amount" label={t.coverageAmount}>
                <Input
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  placeholder={t.coverageAmount}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="price_list" label={t.priceList}>
                <Input
                  style={{ width: '100%' }}
                  placeholder={t.priceList}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="price_list_rate" label={t.rate}>
                <Input
                  style={{ width: '100%' }}
                  placeholder={t.rate}
                  disabled
                />
              </Form.Item>
            </Col>
            {edit && (
              <>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    name="coverage_amount_invoiced"
                    label={t.coverageAmountInvoiced}
                  >
                    <Input
                      style={{ width: '100%' }}
                      min={0}
                      type="number"
                      placeholder={t.coverageAmountInvoiced}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item name="approved_amount" label={t.approvedAmount}>
                    <Input
                      style={{ width: '100%' }}
                      min={0}
                      type="number"
                      placeholder={t.approvedAmount}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item name="paid_amount" label={t.paidAmount}>
                    <Input
                      style={{ width: '100%' }}
                      min={0}
                      type="number"
                      placeholder={t.paidAmount}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {/* <Col xs={24} sm={12} md={8} lg={8}>
          <Form.Item
            name="patient_payable"
            label={t.patientPayable}
          >
            <Input
             style={{ width: '100%' }}
             min={0}
             type='number' 
             placeholder={t.discount}
            />
          </Form.Item>
          </Col> */}
            {/* <Col xs={24} sm={12} md={8} lg={8}>
          <Form.Item
            name="qty_invoiced"
            label={t.qtyInvoiced}
            >
            <Input
             style={{ width: '100%' }}
             min={0}
             type='number' 
             placeholder={t.qtyInvoiced}
            />
          </Form.Item>
          </Col> */}
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default PatientCoverageAdd;
